export { default } from "./PaymentPay";
